module.exports = __webpack_public_path__ + "static/media/bgImageTeam.899331ff.svg";